/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const printer = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.8 11.267H1.933A.933.933 0 0 1 1 10.333V5.667c0-.516.418-.934.933-.934h12.134c.515 0 .933.418.933.934v4.666a.933.933 0 0 1-.933.934H12.2m-8.4-2.8h8.4V15H3.8V8.467Zm8.4-3.734H3.8v-2.8c0-.515.418-.933.933-.933h6.534c.515 0 .933.418.933.933v2.8Z"
    />
  </svg>
)
export default printer
